(() => {
  const roots = document.querySelectorAll('[data-editorial-article]');

  roots.forEach((root) => {
    const content = root.querySelector('[data-editorial-content]');
    if (!content) return;

    const toc = root.querySelector('[data-editorial-toc]');
    const tocList = root.querySelector('[data-editorial-toc-list]');
    const headings = [...content.querySelectorAll('h2, h3')];

    if (toc && tocList && headings.length) {
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;

        const item = document.createElement('li');
        item.dataset.level = heading.tagName.slice(1);

        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        tocList.append(item);
      });

      const tocLinks = [...tocList.querySelectorAll('a')];
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const visible = entries.find((entry) => entry.isIntersecting);
            if (!visible) return;

            tocLinks.forEach((link) => {
              if (link.hash === `#${visible.target.id}`) {
                link.setAttribute('aria-current', 'location');
              } else {
                link.removeAttribute('aria-current');
              }
            });
          },
          { rootMargin: '-15% 0px -70% 0px' }
        );
        headings.forEach((heading) => observer.observe(heading));
      }
    } else if (toc) {
      toc.hidden = true;
    }

    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('erawish-editorial__table-wrap')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'erawish-editorial__table-wrap';
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.querySelector('caption')?.textContent || 'Scrollable table');
      table.before(wrapper);
      wrapper.append(table);
    });

    content.querySelectorAll('iframe').forEach((frame) => {
      if (frame.parentElement?.classList.contains('erawish-editorial__media-wrap')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'erawish-editorial__media-wrap';
      frame.before(wrapper);
      wrapper.append(frame);
    });

    content.querySelectorAll('.erawish-article-slides').forEach((slider, sliderIndex) => {
      if (slider.dataset.enhanced === 'true' || slider.children.length < 2) return;
      slider.dataset.enhanced = 'true';
      slider.setAttribute('role', 'region');
      slider.setAttribute('aria-label', `Image gallery ${sliderIndex + 1}`);

      const controls = document.createElement('div');
      controls.className = 'erawish-editorial__slider-controls';

      const previous = document.createElement('button');
      previous.type = 'button';
      previous.setAttribute('aria-label', 'Previous slide');
      previous.innerHTML = '<span aria-hidden="true">←</span>';

      const next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next slide');
      next.innerHTML = '<span aria-hidden="true">→</span>';

      const move = (direction) => {
        slider.scrollBy({ left: direction * slider.clientWidth, behavior: 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));

      controls.append(previous, next);
      slider.after(controls);
    });

    const copyButton = root.querySelector('[data-copy-article-link]');
    const copyLabel = root.querySelector('[data-copy-label]');
    if (copyButton && copyLabel) {
      const originalLabel = copyLabel.textContent;
      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          copyLabel.textContent = 'Link copied';
          window.setTimeout(() => {
            copyLabel.textContent = originalLabel;
          }, 1800);
        } catch (_error) {
          window.prompt('Copy this link', window.location.href);
        }
      });
    }

    const progress = root.querySelector('[data-reading-progress]');
    if (progress) {
      let ticking = false;
      const updateProgress = () => {
        const rect = content.getBoundingClientRect();
        const travel = Math.max(content.offsetHeight - window.innerHeight, 1);
        const value = Math.min(Math.max(-rect.top / travel, 0), 1);
        progress.style.transform = `scaleX(${value})`;
        ticking = false;
      };
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            window.requestAnimationFrame(updateProgress);
            ticking = true;
          }
        },
        { passive: true }
      );
      updateProgress();
    }
  });
})();
